import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ShortContentComponent } from '@components/common/short-content/short-content.component';
import { ScriptEvidence } from '@models/Sessions/Idea/podcast-api';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ShortDomainPipe } from '@pipes/short-domain.pipe';

@Component({
  selector: 'app-evidence-facts-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    ShortDomainPipe,
    ShortContentComponent,
  ],
  templateUrl: './evidence-facts-list.component.html',
  styleUrl: './evidence-facts-list.component.scss',
})
export class EvidenceFactsListComponent implements OnInit {
  @Input() evidence: ScriptEvidence[];
  @Input() selectable = false;
  @Input() shortContent = true;
  @Input() paginated = false;
  @Input() pageSize = 3;

  evidenceFormArray: FormArray<FormControl<boolean>>;
  evidenceControlCitationMap = new Map<number, FormControl>();
  page = 0;

  get isAnySelected() {
    return this.evidenceFormArray.controls.some(c => c.value);
  }

  get selectedEvidence() {
    return this.evidence.filter((_, i) => this.evidenceFormArray.at(i).value);
  }

  private formBuilder = inject(FormBuilder);

  ngOnInit() {
    if (this.evidence) {
      this.createForm();
    }
  }

  private createForm() {
    this.evidenceFormArray = this.formBuilder.array(
      this.evidence.map(e => {
        const control = this.formBuilder.control(false);
        this.evidenceControlCitationMap.set(e.citation, control);
        return control;
      }),
    );
  }
}
